<template>
  <div
    class="row justify-content-center my-3 scrollable-vertical scrollable-styled-dark"
    :style="isMobile ? '' : 'max-height: 70vh'"
    :class="isMobile ? 'm-auto' : ''"
  >
    <div
      class="col-12 col-md-6 col-lg-5 col-xl-4 z-index-1"
      v-for="w in WalletList()"
      :key="w.id"
    >
      <div
        class="card border-0 shadow transition-hover-top transition-all-ease-500 rounded-xl my-4"
      >
        <div class="bg-orangeSite rounded-xl rounded-bottom-0 p-1">
          <!-- <h3 class="text-center">
            <span class="smaller badge bg-secondary-soft rounded-pill p-2">
              {{ w.title }}
            </span>
          </h3> -->

          <div class="d-flex justify-content-center text-light py-2">
            <span class="ps-2">موجودی حساب:</span>
            <span
              class="pricetable-count fs18px fw-normal js-count-completed"
              >{{ getThousandBalance(w.balance) }}</span
            >
            <!-- <span class="mb-3 align-self-end h3 fw-light">/mo</span> -->
            <span class="mt-1 pe-1 fs13px">{{
              getCurrenyTitle(w.currencyTypeID)
            }}</span>

            <!-- <span v-if="w.currencyTypeID == 2">
              <svg
                width="18px"
                height="18px"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                class="bi bi-currency-dollar mb-0 mt-1 fs13px"
                viewBox="0 0 16 16"
              >
                <path
                  d="M4 10.781c.148 1.667 1.513 2.85 3.591 3.003V15h1.043v-1.216c2.27-.179 3.678-1.438 3.678-3.3 0-1.59-.947-2.51-2.956-3.028l-.722-.187V3.467c1.122.11 1.879.714 2.07 1.616h1.47c-.166-1.6-1.54-2.748-3.54-2.875V1H7.591v1.233c-1.939.23-3.27 1.472-3.27 3.156 0 1.454.966 2.483 2.661 2.917l.61.162v4.031c-1.149-.17-1.94-.8-2.131-1.718H4zm3.391-3.836c-1.043-.263-1.6-.825-1.6-1.616 0-.944.704-1.641 1.8-1.828v3.495l-.2-.05zm1.591 1.872c1.287.323 1.852.859 1.852 1.769 0 1.097-.826 1.828-2.2 1.939V8.73l.348.086z"
                ></path>
              </svg>
            </span>

            <span v-if="w.currencyTypeID == 3">
              <svg
                width="18px"
                height="18px"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                class="bi bi-currency-pound mb-0 mt-1 fs13px"
                viewBox="0 0 16 16"
              >
                <path
                  d="M4 8.585h1.969c.115.465.186.939.186 1.43 0 1.385-.736 2.496-2.075 2.771V14H12v-1.24H6.492v-.129c.825-.525 1.135-1.446 1.135-2.694 0-.465-.07-.913-.168-1.352h3.29v-.972H7.22c-.186-.723-.372-1.455-.372-2.247 0-1.274 1.047-2.066 2.58-2.066a5.32 5.32 0 0 1 2.103.465V2.456A5.629 5.629 0 0 0 9.348 2C6.865 2 5.322 3.291 5.322 5.366c0 .775.195 1.515.399 2.247H4v.972z"
                ></path>
              </svg>
            </span>
            <span v-if="w.currencyTypeID == 4"
              ><svg
                width="18px"
                height="18px"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                class="bi bi-currency-euro mb-0 mt-3 fs13px"
                viewBox="0 0 16 16"
              >
                <path
                  d="M4 9.42h1.063C5.4 12.323 7.317 14 10.34 14c.622 0 1.167-.068 1.659-.185v-1.3c-.484.119-1.045.17-1.659.17-2.1 0-3.455-1.198-3.775-3.264h4.017v-.928H6.497v-.936c0-.11 0-.219.008-.329h4.078v-.927H6.618c.388-1.898 1.719-2.985 3.723-2.985.614 0 1.175.05 1.659.177V2.194A6.617 6.617 0 0 0 10.341 2c-2.928 0-4.82 1.569-5.244 4.3H4v.928h1.01v1.265H4v.928z"
                ></path>
              </svg>
            </span> -->
          </div>

          <!-- <p class="text-center text-light fw-light mb-1">موجودی</p> -->
        </div>

        <!-- <div class="w-100 position-relative">
          <svg
            style="margin-top: -70px"
            width="100%"
            height="50"
            fill="#ffffff"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1000 300"
            preserveAspectRatio="none"
          >
            <path
              style="opacity: 0.15"
              d="M 1000 299 l 2 -279 c -155 -36 -310 135 -415 164 c -102.64 28.35 -149 -32 -232 -31 c -80 1 -142 53 -229 80 c -65.54 20.34 -101 15 -126 11.61 v 54.39 z"
            ></path>
            <path
              style="opacity: 0.3"
              d="M 1000 286 l 2 -252 c -157 -43 -302 144 -405 178 c -101.11 33.38 -159 -47 -242 -46 c -80 1 -145.09 54.07 -229 87 c -65.21 25.59 -104.07 16.72 -126 10.61 v 22.39 z"
            ></path>
            <path
              style="opacity: 1"
              d="M 1000 300 l 1 -230.29 c -217 -12.71 -300.47 129.15 -404 156.29 c -103 27 -174 -30 -257 -29 c -80 1 -130.09 37.07 -214 70 c -61.23 24 -108 15.61 -126 10.61 v 22.39 z"
            ></path>
          </svg>
        </div> -->

        <div class="p-1 p-lg-1">
          <div class="mb-1 btn-outline-light border rounded">
            <button
              type="button"
              class="btn text-end w-100 text-secondary"
              @click="increaseCreditClick(w.id)"
            >
              <svg
                width="18px"
                height="18px"
                xmlns="http://www.w3.org/2000/svg"
                fill="bg-blue"
                class="bi bi-box-arrow-in-down"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M3.5 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2A1.5 1.5 0 0 1 14 6.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-8A1.5 1.5 0 0 1 3.5 5h2a.5.5 0 0 1 0 1h-2z"
                ></path>
                <path
                  fill-rule="evenodd"
                  d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"
                ></path>
              </svg>
              افزایش موجودی
              <a
                @click.self="showEmergencyTooltip"
                class="bnt btn-sm fs13px float-end text-danger mt-1"
                href="https://www.aparat.com/v/hbvs98b"
                target="_blank"
                v-if="this.$store.getters.isOverseas"
              >
                فیلم آموزشی
              </a>
            </button>
          </div>

          <div class="d-flex mb-1">
            <button
              type="button"
              class="btn btn-outline-light border text-end w-100 text-secondary position-relative"
              @click="transferCreditClick(w.id)"
              :disabled="w.balance == 0"
            >
              <svg
                width="18px"
                height="18px"
                xmlns="http://www.w3.org/2000/svg"
                fill="text-warning"
                class="bi bi-folder-symlink"
                viewBox="0 0 16 16"
              >
                <path
                  d="m11.798 8.271-3.182 1.97c-.27.166-.616-.036-.616-.372V9.1s-2.571-.3-4 2.4c.571-4.8 3.143-4.8 4-4.8v-.769c0-.336.346-.538.616-.371l3.182 1.969c.27.166.27.576 0 .742z"
                ></path>
                <path
                  d="m.5 3 .04.87a1.99 1.99 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14h10.348a2 2 0 0 0 1.991-1.819l.637-7A2 2 0 0 0 13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2zm.694 2.09A1 1 0 0 1 2.19 4h11.62a1 1 0 0 1 .996 1.09l-.636 7a1 1 0 0 1-.996.91H2.826a1 1 0 0 1-.995-.91l-.637-7zM6.172 2a1 1 0 0 1 .707.293L7.586 3H2.19c-.24 0-.47.042-.683.12L1.5 2.98a1 1 0 0 1 1-.98h3.672z"
                ></path>
              </svg>
              <!-- <span
                @click.self="showEmergencyTooltip"
                v-if="w.balance != 0"
                style="top: 25%; left: 5%"
                class="badge bg-warning text-dark position-absolute fs-8"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                data-bs-original-title="با اطلاع از شماره عضویت شخص دیگری در کلینیک ارگانیک مایندد میتوانید از اعتبار پولی خود به ایشان هدیه دهید."
                title=""
              >
                راهنما</span
              > -->
              انتقال اعتبار
              <span v-if="w.balance == 0" class="smaller text-danger-gradient"
                >(موجودی ناکافی)</span
              >
            </button>
          </div>

          <!-- <div class="d-flex mb-1">
          <button
            type="button"
            class="btn btn-outline-light border text-end w-100 text-secondary"
            :disabled="w.balance == 0"
          >
            <svg
              width="18px"
              height="18px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-dash-square-dotted"
              viewBox="0 0 16 16"
            >
              <path
                d="M2.5 0c-.166 0-.33.016-.487.048l.194.98A1.51 1.51 0 0 1 2.5 1h.458V0H2.5zm2.292 0h-.917v1h.917V0zm1.833 0h-.917v1h.917V0zm1.833 0h-.916v1h.916V0zm1.834 0h-.917v1h.917V0zm1.833 0h-.917v1h.917V0zM13.5 0h-.458v1h.458c.1 0 .199.01.293.029l.194-.981A2.51 2.51 0 0 0 13.5 0zm2.079 1.11a2.511 2.511 0 0 0-.69-.689l-.556.831c.164.11.305.251.415.415l.83-.556zM1.11.421a2.511 2.511 0 0 0-.689.69l.831.556c.11-.164.251-.305.415-.415L1.11.422zM16 2.5c0-.166-.016-.33-.048-.487l-.98.194c.018.094.028.192.028.293v.458h1V2.5zM.048 2.013A2.51 2.51 0 0 0 0 2.5v.458h1V2.5c0-.1.01-.199.029-.293l-.981-.194zM0 3.875v.917h1v-.917H0zm16 .917v-.917h-1v.917h1zM0 5.708v.917h1v-.917H0zm16 .917v-.917h-1v.917h1zM0 7.542v.916h1v-.916H0zm15 .916h1v-.916h-1v.916zM0 9.375v.917h1v-.917H0zm16 .917v-.917h-1v.917h1zm-16 .916v.917h1v-.917H0zm16 .917v-.917h-1v.917h1zm-16 .917v.458c0 .166.016.33.048.487l.98-.194A1.51 1.51 0 0 1 1 13.5v-.458H0zm16 .458v-.458h-1v.458c0 .1-.01.199-.029.293l.981.194c.032-.158.048-.32.048-.487zM.421 14.89c.183.272.417.506.69.689l.556-.831a1.51 1.51 0 0 1-.415-.415l-.83.556zm14.469.689c.272-.183.506-.417.689-.69l-.831-.556c-.11.164-.251.305-.415.415l.556.83zm-12.877.373c.158.032.32.048.487.048h.458v-1H2.5c-.1 0-.199-.01-.293-.029l-.194.981zM13.5 16c.166 0 .33-.016.487-.048l-.194-.98A1.51 1.51 0 0 1 13.5 15h-.458v1h.458zm-9.625 0h.917v-1h-.917v1zm1.833 0h.917v-1h-.917v1zm1.834 0h.916v-1h-.916v1zm1.833 0h.917v-1h-.917v1zm1.833 0h.917v-1h-.917v1zM4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7z"
              ></path>
            </svg>
            درخواست استرداد
            <span v-if="w.balance == 0" class="smaller text-danger-gradient"
              >(موجودی ناکافی)</span
            >
          </button>
        </div> -->

          <div class="d-flex mb-1">
            <button
              type="button"
              class="btn btn-outline-light border text-end w-100 text-secondary"
              @click="transactionListClick(w.id)"
            >
              <svg
                width="18px"
                height="18px"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                class="bi bi-card-checklist"
                viewBox="0 0 16 16"
              >
                <path
                  d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"
                ></path>
                <path
                  d="M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0zM7 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0z"
                ></path>
              </svg>
              گردش حساب
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { isMobile } from 'mobile-device-detect';
export default {
  data() {
    return {
      isMobile: isMobile,
      // walletList: [],
      currencyTypeList: [],
    };
  },
  inject: ['WalletList', 'SetSelectedTab'],
  methods: {
    showEmergencyTooltip(event) {
      event.stopPropagation();
    },
    getCurrenyTitle(id) {
      let currency = this.currencyTypeList.filter((f) => f.id == id);
      if (currency.length > 0) {
        return currency[0].title;
      }
      return '';
    },
    getThousandBalance(balance) {
      /* eslint-disable */
      return thousandSeprator(balance);
    },
    increaseCreditClick(id) {
      this.SetSelectedTab('increaseCredit', id);
    },
    transferCreditClick(id) {
      this.SetSelectedTab('transferCredit', id);
    },
    refundRequestClick(id) {
      this.SetSelectedTab('refundRequest', id);
    },
    transactionListClick(id) {
      this.SetSelectedTab('transactionList', id);
    },
  },
  async mounted() {
    let that = this;
    await axios.get('/FN/CurrencyType').then((response) => {
      var sortedDate = response.data.sort((a, b) => a.id - b.id);
      that.currencyTypeList = sortedDate.map((m) => {
        return { id: m.id, title: m.title };
      });
    });
    /* eslint-disable */
    var tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl);
    });
  },
};
</script>

<style>
.tooltip {
  --bs-tooltip-bg: #fad776;
  --bs-tooltip-color: #303030;
  --bs-tooltip-font-size: 0.675rem;
  font-family: Vazir;
}
</style>
